import {Alert, Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import {useEffect, useState} from "react";
import {AgentRequestSteps} from "./steps";
import {AgentRequestPersonalInfo} from "./agent_request_personal_info"
import {getUserAgentRequest} from "../../../services/agent/agent_request"
import {BsHourglassSplit} from "react-icons/bs";
import Dict from "../../../helper/dict";
import {roleSwitch} from "../../../services/user/login";
import authManager from "../../../helper/AuthHelper";
import {AgentRequestContext} from "../agent_context";
import {AgentRequestContactInfo} from "./agent_request_contact_info";
import {AgentRequestExpertInfo} from "./agent_request_expert_info";
import {AgentRequestFile} from "./agent_request_file";

export function AgentRequestManagement({changeComponent}) {

  const [activeStep, setActiveStep] = useState(null);
  const [agentRequest, setAgentRequest] = useState();

  const [isLastStep, setIsLastStep] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(false);
  const [allowedStep, setAllowedStep] = useState(null);

  const [agentLog, setAgentLog] = useState("no_one");

  const handleNext = (step) => (setActiveStep(step))
  const handlePrev = (step) => (setActiveStep(step))

  useEffect(() => {
    async function getData() {
      const result = await getUserAgentRequest();
      if (result.status === 200) {
        const {agent_request, agent_log} = result.data;
        setAgentRequest(agent_request);
        setActiveStep(agent_request?.step ?? 0);
        setAllowedStep(agent_request?.step ?? 0);
        setAgentLog(agent_log)
      } else {
        setAgentRequest(null);
        setActiveStep(0);
        setAllowedStep(0);
      }
    }

    getData()
  }, []);

  useEffect(() => {
    setAgentLog(agentLog)
  }, [agentLog]);

  useEffect(() => {
    if (!(agentRequest?.id)) {
      setAllowedStep(0)
    } else {
      setAllowedStep(agentRequest.step)
    }
  }, [agentRequest])

  useEffect(() => {
    if (allowedStep <= activeStep) {
      setAllowedStep(activeStep)
    }
  }, [activeStep]);

  async function changeRole() {
    const data = {
      role_id: 2,
    };
    let result;

    result = await roleSwitch(data);

    if (result.status === 200) {
      authManager.loginHandler(result.data)
      window.location.href = '/';
      localStorage.setItem("lastClicked", "agent_request")
    }
  }

  const messages = {
    'new': {
      'text': 'کاربر گرامی، درخواست شما جهت بررسی و تائید اطلاعات اولیه به پلتفرم مباشر ارسال شد.',
      'icon': <BsHourglassSplit className="flex ml-2 text-xl"/>
    },
    'accepted': {
      'text': 'درخواست شما پذیرفته شد',
      'icon': <BsHourglassSplit className="flex ml-2 text-xl"/>
    },
    'rejected': {
      'text': 'درخواست شما رد شد',
      'icon': <BsHourglassSplit className="flex ml-2 text-xl"/>
    },
  }

  return (
    <AgentRequestContext.Provider value={{
      agentRequest,
      setAgentRequest,
      agentLog,
      setAgentLog,
      activeStep,
      setActiveStep,
      isLastStep,
      setIsLastStep,
      isFirstStep,
      setIsFirstStep,
      allowedStep,
      setAllowedStep,
      handleNext,
      handlePrev,
    }}>
      <div className="">
        <Card className="pt-8 h-full">
          <CardHeader floated={true} shadow={false} className="shadow-xl px-4">
            <div className="mb-8 flex items-center justify-between p-4">
              <Typography variant="h5" color="blue-gray">همکاری‌باما</Typography>
            </div>
            {
              agentLog && agentLog.status &&
              <>
                <Alert className="flex flex-row my-4">
                  <Typography className="flex font-semibold">
                    {messages[agentLog.status]['icon']}
                    {messages[agentLog.status]['text']}
                  </Typography>
                  {agentLog.status === 'accepted' &&
                    <div className="flex flex-col gap-y-2 mt-4 mb-4">
                      <Typography variant="h5" className="">
                        به منظور شروع فعالیت در پلتفرم مباشر، اقدامات زیر را انجام دهید:
                      </Typography>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        changeRole();
                      }}>
                        - تغییر نقش به مباشر
                      </Button>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        localStorage.setItem("defaultItem", "agent_request");
                        changeComponent("agent_branch_fee")
                      }}>
                        - تعریف تعرفه خدمات، در قسمت آیتم های همکاری
                      </Button>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        localStorage.setItem("defaultItem", "agent_request");
                        changeComponent("schedule")
                      }}>
                        - تعریف برنامه زمان بندی، در قسمت مشاوره
                      </Button>
                      <Button variant="text" color="white" className="max-w-fit" onClick={() => {
                        localStorage.setItem("defaultItem", "agent_request");
                        changeComponent("agent_branch_document")
                      }}>
                        - تعریف مدارک مورد نیاز هر گرایش، در قسمت خدمات من
                      </Button>
                    </div>
                  }
                  {agentLog && agentLog.comment &&
                    <div className="flex flex-row mb-4">
                      <Typography variant="h5" className="ml-4">
                        {`${Dict('description')} ادمین: `}
                      </Typography>
                      <Typography>
                        {agentLog.comment}
                      </Typography>
                    </div>
                  }
                </Alert>


              </>
            }


          </CardHeader>
          <CardBody className="overflow-x-auto w-full h-full overflow-y">
            <div className="mb-40">
              <AgentRequestSteps/>
            </div>
            <div className="mt-20">
              {activeStep === 0 && <AgentRequestPersonalInfo/>}
              {activeStep === 1 && <AgentRequestContactInfo/>}
              {activeStep === 2 && <AgentRequestExpertInfo/>}
              {activeStep === 3 && <AgentRequestFile/>}
            </div>

          </CardBody>
        </Card>
      </div>
    </AgentRequestContext.Provider>
  );
}